//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
import { makeStyles } from '@material-ui/core';
import { BookmarkBorderOutlined as BookmarkBorderOutlinedIcon, Bookmark as BookmarkIcon, Delete as DeleteIcon } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { setClassNameInDefns } from '../../common/definitionHelper';
import { JOB_TITLE_MISSING } from '../../common/constants';
import { getCityStateCountryText } from '../../common/textHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
import _get from 'lodash/get';
// import _includes from 'lodash/includes';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        itemBox: {
            overflowY: 'scroll',
            '&::-webkit-scrollbar': {
                width: '0.4em',
            },
            '&::-webkit-scrollbar-track': {
                '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(0,0,0,.1)',
                borderRadius: '5px',
            },
        },
        popItem: {
            display: 'flex',
            alignItems: 'center',
        },
        popItemMiddleSection: {
            flex: 1,
            padding: '5px',
            minWidth: '230px',
        },
        jobTitle: {
            fontSize: '16px',
            fontWeight: 'bold',
        },
        location: {
            fontSize: '14px',
        },

        bookmarkJobIconButton: {
            component: 'span',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------

const getDefns = params => {
    const { classes, props, handleClickBookmarkIconButton, handleClickDeleteIconButton, job } = params;

    const { variant = 'bookmark' } = props;
    let iconButtonOnClick = handleClickBookmarkIconButton;

    switch (variant) {
        case 'delete':
            iconButtonOnClick = handleClickDeleteIconButton;
            break;
        default:
        // do nothing
    }

    const defns = {
        subHeading: {
            variant: 'body1',
        },
        jobTitle: {
            value: _get(job, 'jobTitle', JOB_TITLE_MISSING),
        },
        location: {
            value: getCityStateCountryText(job.city, job.state, job.country),
        },
        bookmarkJobIconButton: {
            onClick: iconButtonOnClick,
        },
    };

    setClassNameInDefns(defns, classes);
    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const JobListingBookmark = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { variant = 'bookmark', job, isBookmarked, onBookmarkButtonClick, onDeleteButtonClick } = props;

    //---------------------------------------------------------------------
    // Event handlers
    //---------------------------------------------------------------------
    const handleClickBookmarkIconButton = () => {
        onBookmarkButtonClick && onBookmarkButtonClick(job, !isBookmarked); // assume the passed-in handler already know which job to update
    };

    const handleClickDeleteIconButton = () => {
        onDeleteButtonClick && onDeleteButtonClick(job);
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        props,
        handleClickBookmarkIconButton,
        handleClickDeleteIconButton,
        job,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div>
            <div {...defns.itemBox}>
                <div {...defns.popItem}>
                    <div {...defns.popItemMiddleSection}>
                        <AfitdTypography {...defns.jobTitle} />
                        <AfitdTypography {...defns.location} />
                    </div>

                    <div>
                        {variant === 'bookmark' && (
                            <IconButton {...defns.bookmarkJobIconButton}>{isBookmarked ? <BookmarkIcon color="primary" /> : <BookmarkBorderOutlinedIcon />}</IconButton>
                        )}
                        {variant === 'delete' && (
                            <IconButton {...defns.bookmarkJobIconButton}>
                                <DeleteIcon />
                            </IconButton>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobListingBookmark;
